// src/components/forms/FormRadioGroup.jsx
import { forwardRef } from 'react';

export const FormRadioGroup = forwardRef(({
  label,
  name,
  options = [],
  value,
  error,
  required,
  helperText,
  inline = false,
  className = '',
  inputClassName='',
  containerClassName = '',
  ...props
}, ref) => {
  return (
    <div className={`space-y-2 ${containerClassName}`}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className={`space-y-2 ${className} ${inline ? 'sm:space-y-0 sm:space-x-6 sm:flex sm:items-center' : ''}`}>
        {options.map((option) => (
          <div key={option.value} className="flex items-center">
            <input
              ref={ref}
              type="radio"
              id={`${name}-${option.value}`}
              name={name}
              value={option.value}
              checked={value !== undefined ? value === option.value : undefined}
              className={`
                h-4 w-4 text-blue-600 border-gray-300 bg-transparent
                focus:ring-blue-500
                ${error ? 'border-red-300 dark:border-red-500/50' : ''}
                ${inputClassName}
              `}
              {...props}
            />
            <label
              htmlFor={`${name}-${option.value}`}
              className="ml-2 block text-sm text-gray-700 dark:text-gray-300"
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
      {error ? (
        <p className=" mt-1 text-sm text-red-600 dark:text-red-400">{error}</p>
      ) : helperText ? (
        <p className="text-sm text-gray-500">{helperText}</p>
      ) : null}
    </div>
  );
});
